import { TNodeEntry, wrapNodes } from '@udecode/plate-core';
import {
  ELEMENT_ACCORDION_ITEM,
  ELEMENT_ACCORDION_ITEM_CONTENT,
} from '../../../pluginKeys';
import { DreamEditor } from '../../../types';

export const normalizeNonAccordionItemChild = (
  editor: DreamEditor,
  entry: TNodeEntry,
) => {
  const [, path] = entry;

  // wrap non accordion_item child with accordion_item
  wrapNodes(
    editor,
    {
      type: ELEMENT_ACCORDION_ITEM,
      children: [
        {
          type: ELEMENT_ACCORDION_ITEM_CONTENT,
          children: [],
        },
      ],
    },
    { at: path },
  );

  return true;
};
